import { withAdminLayout } from 'ui/components/layouts';
import { DashboardContainer } from 'ui/components/pages/user/Dashboard';

export const Dashboard = withAdminLayout(DashboardContainer);
